import { render, staticRenderFns } from "./tagNave.vue?vue&type=template&id=24384c3c&scoped=true&"
import script from "./tagNave.vue?vue&type=script&lang=js&"
export * from "./tagNave.vue?vue&type=script&lang=js&"
import style0 from "./tagNave.vue?vue&type=style&index=0&id=24384c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24384c3c",
  null
  
)

export default component.exports